import { useState, useCallback, FocusEvent } from 'react';

import { IUser } from '@/features/user/store/user.model';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { useAsyncInput } from '@/hooks/useAsyncInput';
interface IParentUserInput {
  key?: string;
  initialValue?: string;
}

export const useParentUserInput = ({ key = 'parentUserId', initialValue }: IParentUserInput) => {
  const [inputValue, setInputValue] = useState(initialValue);

  const config = useDashboardConfig();

  const isValid = inputValue?.length !== 0;

  const handleUser = (response) => (response?.['users']?.length > 0 ? response?.['users'] : undefined);

  const { iconStatus, status, data } = useAsyncInput<IUser>({
    key,
    inputValue,
    url: `${config.api.baseUrl}/v1/users/${inputValue}`,
    handleResponse: handleUser,
    shouldSkip: !isValid,
  });

  const handleAsyncBlur = useCallback((event: FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setInputValue(event.target.value);
  }, []);

  return { iconStatus, status, handleAsyncBlur, data };
};
